import { supabase } from '../supabaseClient';

/**
 * POSTs JSON to one of our /api routes with the current user's access token,
 * so the server can check who is calling.
 */
export async function postApi(path: string, body: unknown): Promise<Response> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;

  return fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  });
}
